<template>
  <div class="tool">
    <!--工具-->
    <transition>
      <div
        @click="toolbar = !toolbar"
        v-show="toolbar"
        class="toolbar"
        title="显示"
      >
        <span>O</span>
      </div>
    </transition>

    <transition>
      <div ref="meun" v-show="!toolbar" class="toolbars">
        <div @click="toolbar = !toolbar" title="关闭" class="toolbars-close">
          <i>X</i>
        </div>
        <div class="menu-bar">
          <ul class="clickfun">
            <li>
              <div class="ues-i">
                <a-icon type="cloud" theme="twoTone" />
              </div>
              <div class="section" hidden>
                待更新
                <span class="triangle"></span>
              </div>
            </li>
            <li>
              <div class="ues-i">
                <a-icon type="skin" theme="twoTone" />
              </div>
              <div class="section" hidden>
                待更新
                <span class="triangle"></span>
              </div>
            </li>
            <li>
              <div class="ues-i">
                <a-icon type="bug"  theme="twoTone"/>
              </div>
              <div class="section" hidden>
                <label for="search">
                  待更新
                  <!-- <button class="search-button" :title="search">{{search}}</button>
                  <input id="search" name="search" type="text" placeholder="全文搜索" /> -->
                </label>
                <span class="triangle"></span>
              </div>
            </li>
            <li>
              <div class="ues-i">
                <a-icon type="idcard" theme="twoTone" />
              </div>
              <div class="section" hidden>
                <figure>
                  <img :src="this.$store.state.boxMessage.qrcode" alt="站长二维码" />
                  <figcaption>联系站长</figcaption>
                </figure>
                <!-- <img :src="" alt="站长二维码" />
                <p>联系站长</p> -->
                <span class="triangle"></span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Tool",
  data() {
    return {
      toolbar: true, //切换中枢
      search: "搜索",
      showpasswrod: true,
    };
  },
  mounted() {
    //组件已经渲染完毕执行
    window.onload = this.clickfun;
  },
  methods: {
    clickfun() {
      var ulp = document.getElementsByClassName("clickfun")[0]; //获取大容器
      var usei = ulp.getElementsByClassName("ues-i"); //获取容器里面的所有li
      var stn = ulp.getElementsByClassName("section"); //获取容器里面的所有Panel面板
      var index = -1; //被赋值项
      for (var i = 0; i < usei.length; i++) {
        //遇坑事件，for循环内函数的具体不能绑定，只能以这样的形式：函数名称(参数)
        AddEvent(i);
      }

      function AddEvent(PanelIndex) {
        //为元素绑定事件
        usei[PanelIndex].addEventListener("click", () => {
          //为li添加点击事件
          ShowPanel(PanelIndex); //每次被点击执行，都执行一下判断方法
          if (stn[PanelIndex].hidden) {
            // usei[PanelIndex].style.backgroundColor = "rgb(243, 243, 241)";
          } else {
            // usei[PanelIndex].style.backgroundColor = "slateblue";
          }
        });
        // stn[PanelIndex].hidden = true;
      }

      function ShowPanel(PanelIndex) {
        //判断方法
        // usei[PanelIndex].style.backgroundColor = "slateblue"; //li变色
        if (index == PanelIndex) {
          //重复点击li
          //同面板
          stn[index].hidden = !stn[index].hidden;
          return; //直接跳出方法不执行下面判断
        }
        if (index != -1) {
          //不重复点击li的情况
          stn[index].hidden = true; //面板隐藏
          // usei[index].style.backgroundColor = "rgb(243, 243, 241)"; //li还原白色背景
        }
        index = PanelIndex; //为被赋值项赋值，用于下一次判断用户是否点击同样li
        stn[index].hidden = false; //面板隐藏
      }
    },
    // showPasswrod() {
    //   var show = document.getElementById("o-o"); //圆点按钮
    //   var passwordInput = document.getElementById("password"); //获取密码框
    //   this.showpasswrod = !this.showpasswrod;
    //   if (this.showpasswrod) {
    //     show.style.backgroundColor = "#000"; //背景黑色
    //     passwordInput.type = "password"; //密码不可见
    //   } else {
    //     show.style.backgroundColor = "#fff"; //背景白色
    //     passwordInput.type = "text"; //密码可见
    //   }
    // }
  },
  watch: {
    toolbar() {
      //每当切换中枢变化，则初始化面板状态
      var ulp = document.getElementsByClassName("clickfun")[0]; //获取大容器
      var usei = ulp.getElementsByClassName("ues-i"); //获取容器里面的所有li
      var stn = ulp.getElementsByClassName("section"); //获取容器里面的所有Panel
      for (let i = 0; i < stn.length; i++) {
        stn[i].hidden = true;
        // usei[i].style.backgroundColor = "rgb(243, 243, 241)";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tool {
  bottom: 0;
  //工具组件样式
  .v-enter,
  .v-leave-to {
    opacity: 0;
    transform: translateX(50px);
  }
  .v-enter-active,
  .v-leave-active {
    transition: all 0.3s ease;
  }

  .toolbar {
    position: fixed;
    top: 25%;
    right: 0;
    width: 50px;
    line-height: 50px;
    font-weight: bold;
    text-align: center;
    border-radius: 20% 20%;
    background-color: slateblue;
    transition: all 1s ease;
    cursor: pointer;
    z-index: 10;
  }

  .toolbars {
    position: fixed;
    right: 0;
    top: 25%;
    width: 50px;
    min-height: 50%;
    background: rgba(51, 51, 51, 0.6);
    border-radius: 5% 5%;
    z-index: 99;
    .toolbars-close {
      margin-top: 10px;
      color: rgba(241, 241, 241, 0.931);
      cursor: pointer;
    }
    .menu-bar {
      position: absolute;
      top: 25%;
      right: 15%;
      li {
        position: relative;
        line-height: 30px;
        border-top: #464646 1px solid;
        border-bottom: #464646 1px solid;
        .ues-i {
          margin: 5px auto;
          padding-left: 2px;
          line-height: 30px;
          width: 38px;
          font-size: 1.5rem;
          cursor: pointer;
        }
        .section {
          position: absolute;
          right: 50px;
          top: 0;
          padding: 25px;
          width: max-content;
          background: linear-gradient(
            -90deg,
            rgba(8, 8, 8, 0.6),
            1%,
            rgba(243, 243, 241, 0.6)
          );
          border-radius: 5% 5%;
          box-shadow: -5px 3px 3px rgba(0, 0, 0, 0.1);
          transform: rotateX(-150px);
          transition: all 1s ease;
          #o-o {
            position: absolute;
            right: 5px;
            top: 65px;
            width: 10px;
            height: 10px;
            border: #000 solid 1px;
            border-radius: 50% 50%;
            background-color: #000;
            cursor: pointer;
          }
          .sign {
            margin-top: 10px;
          }
          .sign > button {
            float: right;
            margin-right: 15%;
            border-radius: 10% 10%;
            border: none;
            padding: 8px;
            color: #fff;
            background-color: #000;
            box-shadow: 5px 3px 5px rgba(0, 0, 0, 0.1);
            cursor: pointer;
          }
          .sign > button:last-child {
            background-color: #631818;
          }
          .search-button {
            margin-right: 5px;
            padding: 5px;
            border: none;
            color: #fff;
            box-shadow: 5px 3px 5px rgba(0, 0, 0, 0.1);
            border-radius: 100% 100%;
            background-color: #000;
            cursor: pointer;
          }
          button:hover {
            background-color: slateblue;
            box-shadow: none;
          }
          input {
            float: right;
            height: 30px;
            width: 200px;
            background-color: rgba(243, 243, 241);
            text-align: center;
          }
          h5 {
            margin-top: 10px;
            border-radius: 30% 30%;
            background-color: slateblue;
          }
          img {
            width: 150px;
            height: 150px;
          }
          figcaption {
            font-weight: 600;
          }
        }
        .triangle {
          position: absolute;
          float: right;
          width: 8px;
          height: 8px;
          right: -7px;
          top: 15px;
          border-top: 4px solid transparent;
          border-right: 8px solid rgb(0, 0, 0);
          border-bottom: 4px solid transparent;
          transform: rotate(-180deg);
          transition: all 0.5s ease;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/index/Tool.vue